// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { mode as _mode } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the mode chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 34443
 * Chain Name: Mode Mainnet
 * Default Block Explorer: https://modescan.io
 * Default RPC URL: https://mainnet.mode.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { mode } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: mode,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const mode = createCommon({
	..._mode,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
